import * as React from "react"
import * as styles from '../styles/staff_section.module.css'
import { Header1, Header2 } from "./heading_elements";
import { TwitterX, Tumblr, Homepage } from "./social"

export function StaffSection() {
    return (
        <section className={styles.section_staff}>
          <Header1 headerTitle={"スタッフ"}></Header1>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"アートディレクター"}/>
            <div className={styles.name}>厳男子</div>
            <div className={styles.info}>
              <p className={styles.info_text}>『ムラサキ』LINEコミックス等</p>
            </div>
            <div className={styles.sns_icons}>
              <TwitterX handle={"hamigakiotoko"}/>
            </div>            
          </div>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"メインキャラクターデザイン"}/>
            <div className={styles.name}>ゆつもえ</div>
            <div className={styles.sns_icons}>
              <TwitterX handle={"yutsumoe"}/>
              <Tumblr handle={"yutsumoe"} />
            </div>
          </div>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"服飾・キャラクターデザイン"}/>
            <div className={styles.name}>中本有祐莉</div>
            <div className={styles.info}>
              <p className={styles.info_text}>『ビターダイヤモンド』(白泉社)</p>
            </div>
            <div className={styles.sns_icons}>
              <TwitterX handle={"yr_nkmt2080"}/>
            </div>            
          </div>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"音楽"}/>
            <div className={styles.name}>成塚優貴(Soy Sauce Studio)</div>
            <div className={styles.info}>
              <p className={styles.info_text}>『a day in the light』（Soy Sauce Studio）</p>
              <p className={styles.info_text}> 『昼の庭』（corner of kanto）</p>
            </div>
            <div className={styles.sns_icons}>
              <Homepage url={"https://www.soysaucestudio.jp.net/"} />
            </div>
          </div>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"メインテーマ"}/>
            <div className={styles.name}>山下Topo洋平</div>
            <div className={styles.info}>
              <p className={styles.info_text}>『KOKOPELLI』（山下Topo洋平）</p>
              <p className={styles.info_text}>『Tierra』（Tierra Cuatro）</p>              
            </div>
            <div className={styles.sns_icons}>
              <Homepage url={"https://topoyohei.com/"} />
            </div>
          </div>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"ロゴデザイン・UI/UX"}/>
            <div className={styles.name}>高垣</div>
            <div className={styles.sns_icons}>
              <TwitterX handle={"102__design"}/>
              <Homepage url={"https://tmm-design.work/"} />
            </div>
          </div>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"プロデューサー・ナラティブデザイナー・演出・監督補助"}/>
            <div className={styles.name}>
              米原将磨
            </div>
            <div className={styles.info}>
              <p className={styles.info_text}>合同会社フヒトベ代表</p>
            </div>
            <div className={styles.sns_icons}>
              <TwitterX handle={"penguinmeditate"}/>
              <Homepage url={"https://fuhitobe.jp/"} />
            </div>   
          </div>
          <div className={styles.staff_member}>
            <Header2 headerTitle={"原作・監督・脚本・技術"}/>
            <div className={styles.name}>太田一行</div>
          </div>
        </section>
    )
  }
  